(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('master-buy-now')) {
  customElements.define('master-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.form = this.closest('form');
      this.host = this.closest('.shopify-section');
      this.label = this.button.textContent;
      this.controller = new AbortController();
      this.button.addEventListener('click', this.checkout, { signal: this.controller.signal });
      this.host?.addEventListener('shopify:product:select', this.variantChanged, { signal: this.controller.signal });
      window.addEventListener('pageshow', this.reset, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    reset = () => {
      this.busy = false;
      this.restoreAddButton?.();
      this.restoreAddButton = null;
      this.button.disabled = false;
      this.button.textContent = this.label;
      this.button.removeAttribute('aria-busy');
    };
    variantChanged = (event) => {
      const card = event.target.closest?.('product-card');
      if (card && !card.contains(this)) return;
      const pending = event.promise;
      this.pending = pending;
      this.button.disabled = true;
      Promise.resolve(pending).then(() => {
        if (this.pending !== pending || this.busy) return;
        this.pending = null;
        this.button.disabled = false;
      }).catch(() => {
        if (this.pending !== pending) return;
        this.pending = null;
        this.button.disabled = true;
      });
    };
    checkout = async () => {
      if (this.busy || this.pending || !this.form?.reportValidity()) return;
      const addButton = this.form.querySelector('[ref="addToCartButton"]');
      if (addButton?.disabled || this.hidden) return;
      const data = new FormData(this.form);
      if (!data.get('id')) return;
      this.busy = true;
      this.error.hidden = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.busy;
      const addWasDisabled = addButton?.disabled;
      if (addButton) {
        addButton.disabled = true;
        this.restoreAddButton = () => { addButton.disabled = Boolean(addWasDisabled); };
      }
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const message = typeof result.description === 'string' ? result.description : this.dataset.error;
          throw new Error(message);
        }
        window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.error.textContent = error instanceof Error && error.message !== 'Failed to fetch' ? error.message : this.dataset.error;
        this.error.hidden = false;
        if (addButton) addButton.disabled = Boolean(addWasDisabled);
        this.reset();
      }
    };
  });
}
  } catch(e) { console.error(e); }
})();

})();
